<script>
const { VUE_APP_API_HOST, VUE_APP_FB_ID, VUE_APP_FB_SECRET } = process.env

const FB_URL_PROFILE ='https://graph.facebook.com/me?fields=id,first_name,last_name,email,picture,locale,location,timezone&access_token='
const FB_URL_TOKEN = `https://graph.facebook.com/oauth/access_token?client_id=${VUE_APP_FB_ID}&client_secret=${VUE_APP_FB_SECRET}&grant_type=fb_exchange_token&fb_exchange_token=`
//const FB_URL_PAGES = 'https://graph.facebook.com/me/accounts?limit=100&fields=id,name,link,access_token,picture&access_token='
const FB_URL_PAGES = 'https://graph.facebook.com/me/accounts?limit=100&fields=id,name,link,access_token,picture,location,parent_page&access_token='

const FB_URL_GROUPS_START = 'https://graph.facebook.com/'
const FB_URL_GROUPS_END = '/groups?admin_only=true&limit=100&fields=id,name,link,access_token,picture&access_token='

const INSTA_URL_PAGES_START = 'https://graph.facebook.com/'
const INSTA_URL_PAGES_END = '?limit=100&fields=instagram_business_account&access_token='

const INSTA_URL_PROFILE_START = 'https://graph.facebook.com/'
const INSTA_URL_PROFILE_END = '?fields=id,media_count,username,profile_picture_url&access_token='

const GOOGLE_URL_ACCOUNTS = 'https://mybusinessaccountmanagement.googleapis.com/v1/accounts'

export default {
  methods: {
    //getGoogle("/ting", (req,res) =>)

    getGoogleAccounts(acces_token){
      return this.$http
                .get(
                  `${GOOGLE_URL_ACCOUNTS}`,
                  {
                    headers: {
                      Authorization: `Bearer ${acces_token}`
                    }
                  }
                )
                .then(res => res, err => err)
      },
    getTwitterRedirectLink(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/twitter`, body)
        .catch(err => { console.error('getTwitterRedirectLink', err); throw err })
    },

    postTwitterVerify(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/twitter/signed`, body)
        .catch(err => { console.error('postTwitterVerify', err); throw err })
    },

    addTwitterV2(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/twitter-v2`, body, {
          headers: localStorage.getItem('token') ? {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          } : {} })
        .catch(err => { console.error('addTwitterV2', err); throw err })
    },

    addTwitterV1(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/twitter-v1`, body, {
          headers: localStorage.getItem('token') ? {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          } : {} })
        .catch(err => { console.error('addTwitterV1', err); throw err })
    },

    postPinterestVerify(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/pinterest/signed`, body)
        .catch(err => { console.error('postPinterestVerify', err); throw err })
    },

    postLinkedinVerify(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/linkedin/signed` ,body, {
          headers: localStorage.getItem('token') ? {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          } : {} })
        .catch(err => { console.error('postLinkedinVerify', err); throw err })
    },

    postYoutubeVerify(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/youtube/signed` ,body, {
          headers: localStorage.getItem('token') ? {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          } : {} })
        .catch(err => { console.error('postYoutubeVerify', err); throw err })
    },

    postTiktokVerify(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/tiktok/signed` ,body, {
          headers: localStorage.getItem('token') ? {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          } : {} })
        .catch(err => { console.error('postLinkedinVerify', err); throw err })
    },

    postThreadsVerify(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/threads/signed` ,body, {
          headers: localStorage.getItem('token') ? {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          } : {} })
        .catch(err => { console.error('postThreadsVerify', err); throw err })
    },

    postInstagramBusinessVerify(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/instagram_business/signed` ,body, {
          headers: localStorage.getItem('token') ? {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          } : {} })
        .catch(err => { console.error('postInstagramBusinessVerify', err); throw err })
    },

    getLinkedInOrganizations(){
      return this.$http
        .get(`${VUE_APP_API_HOST}/linkedin/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .catch(err => { console.error('getLinkedInOrganizations', err); throw err })
    },

    getUserInfoFb(accessToken){
      return this.$http
        .get(FB_URL_PROFILE + accessToken)
        .catch(err => { console.error('getUserInfoFb', err); throw err })
    },

    getLongLiveToken(accessToken){
      return this.$http
        .get(FB_URL_TOKEN + accessToken)
        .catch(err => { console.error('getLongLiveToken', err); throw err })
    },

    retrievePages(accessToken){
      return this.$http
        .get(FB_URL_PAGES + accessToken)
        .catch(err => { console.error('retrievePages', err); throw err })
    },

    
    retrieveGroups(userId, accessToken){
      return this.$http
        .get(FB_URL_GROUPS_START + userId + FB_URL_GROUPS_END + accessToken)
        .catch(err => { console.error('retrieveGroups', err); throw err })
    },

    retrieveInstaPages(idPageFB, accessToken){
      return this.$http
        .get(INSTA_URL_PAGES_START + idPageFB + INSTA_URL_PAGES_END + accessToken)
        .catch(err => { console.error('retrieveInstaPages', err); throw err })
    },

    getUserInfoInsta(idPageInsta, accessToken){
      return this.$http
        .get(INSTA_URL_PROFILE_START + idPageInsta + INSTA_URL_PROFILE_END + accessToken)
        .catch(err => { console.error('getUserInfoInsta', err); throw err })
    },

    postLoginBluesky(body) {
      return this.$http
        .post(`https://bsky.social/xrpc/com.atproto.server.createSession` ,body, {
          headers: {
            "Content-Type": "application/json"
          }})
        .catch(err => { console.error('postLoginBluesky', err); throw err })
    },
    
    getBlueskyProfile(profile, accessToken) {
      return this.$http
        .get(`https://bsky.social/xrpc/app.bsky.actor.getProfile?actor=${profile}` , {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }})
        .catch(err => { console.error('getBlueskyProfile', err); throw err })

    }

  }
}
</script>
